import { useState } from "react";
import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { ASSETS, TRUST_ITEMS } from "../../config/site";
import { ShieldCheck, Award, Landmark, FileCheck, CalendarClock, FolderOpen } from "lucide-react";

const ICONS = [ShieldCheck, Award, Landmark, FileCheck, CalendarClock, FolderOpen];

const BadgeImg = ({ asset, alt }) => {
  const [ok, setOk] = useState(true);
  if (!ok) return null;
  return (
    <img
      src={asset.local}
      onError={() => setOk(false)}
      alt={alt}
      loading="lazy"
      className="h-16 w-auto max-w-[120px] object-contain"
      data-testid={`trust-badge-${alt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    />
  );
};

export const Trust = () => (
  <Section
    id="trust"
    overline="Trust & approvals"
    title="Verify everything before you pay anything"
    sub="Every document is open for inspection at the site office. Come see the file, then the land."
  >
    <div className="mb-8 flex items-center gap-6">
      <BadgeImg asset={ASSETS.badgeHaryana} alt="Govt of Haryana approval" />
      <BadgeImg asset={ASSETS.badgeMsme} alt="MSME cluster approval" />
    </div>
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {TRUST_ITEMS.map((t, i) => {
        const Icon = ICONS[i];
        return (
          <Reveal key={t.title} delay={(i % 3) * 0.08}>
            <div className="h-full border border-border bg-paper-light p-6" data-testid={`trust-item-${i}`}>
              <Icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
              <h3 className="mt-4 font-display text-xl font-medium text-forest">{t.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#4A4C4A]">{t.desc}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </Section>
);
